module.exports = __webpack_public_path__ + "img/386.a86cfb61.png";